export default __webpack_public_path__ + "static/media/date.dd650277.svg";